import api from './api'; // Import Axios instance

export const getAppUserStats = async (fromDate, toDate) => {
    try {
        const params = {};
        if (fromDate) params.from = fromDate;
        if (toDate) params.to = toDate;

        const response = await api.get('/report/appUserStats/', { params });

        const appUserStats = response.data.payload;
        return appUserStats;

    } catch (error) {
        console.error('Failed to get app user data report');
        throw error;
    }
};

export const getUserDemographics = async (demographicFilter) => {
    try {
        const params = {};
        if (demographicFilter) params.filter = demographicFilter;

        const response = await api.get('/report/userDemographics/', { params });

        const userDemographics = response.data.payload;
        return userDemographics;

    } catch (error) {
        console.error('Failed to get user demographic data report');
        throw error;
    }
};